import * as React from "react";
import {css, Theme} from "@emotion/react";

import {OfferBoxBase} from "../../atoms/OfferBoxBase";

export const OfferBoxPlaceholder = () => {
    return (
        <OfferBoxBase>
            <div css={OfferBoxPlaceholderStyles}>
                <div css={OfferBoxPlaceholderInnerStyles}>
                    <div css={OfferBoxImage} />
                    <div css={OfferBoxPlaceholderInfoHolderStyles}>
                        <div css={OfferBoxPlaceholderInfo1Styles} />
                        <div css={OfferBoxPlaceholderInfo2Styles} />
                    </div>
                </div>
            </div>
        </OfferBoxBase>
    );
};

const OfferBoxImage = (theme: Theme) => css`
    height: 45%;
    background-color: ${theme.colors.gray[200]};
    width: 100%;
`;

const OfferBoxPlaceholderInfoHolderStyles = css`
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    flex: 1;
    padding: 0 3rem 3rem;
`;
const OfferBoxPlaceholderInfo1Styles = (theme: Theme) => css`
    height: 60%;
    background-color: ${theme.colors.gray[200]};
    margin-bottom: 1.5rem;
`;
const OfferBoxPlaceholderInfo2Styles = (theme: Theme) => css`
    bottom: 1.5rem;
    height: 39px;
    background-color: ${theme.colors.gray[200]};
`;
const OfferBoxPlaceholderStyles = css`
    height: 0;
    overflow: hidden;
    padding-top: 125%;
    background: white;
    position: relative;
`;

const OfferBoxPlaceholderInnerStyles = css`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
import * as React from "react";
import {css, Theme} from "@emotion/react";

import {OfferBoxBase} from "../../atoms/OfferBoxBase";

export const OfferBoxPlaceholder = () => {
    return (
        <OfferBoxBase>
            <div css={OfferBoxPlaceholderStyles}>
                <div css={OfferBoxPlaceholderInnerStyles}>
                    <div css={OfferBoxImage} />
                    <div css={OfferBoxPlaceholderInfoHolderStyles}>
                        <div css={OfferBoxPlaceholderInfo1Styles} />
                        <div css={OfferBoxPlaceholderInfo2Styles} />
                    </div>
                </div>
            </div>
        </OfferBoxBase>
    );
};

const OfferBoxImage = (theme: Theme) => css`
    height: 45%;
    background-color: ${theme.colors.gray[200]};
    width: 100%;
`;

const OfferBoxPlaceholderInfoHolderStyles = css`
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    flex: 1;
    padding: 0 3rem 3rem;
`;
const OfferBoxPlaceholderInfo1Styles = (theme: Theme) => css`
    height: 60%;
    background-color: ${theme.colors.gray[200]};
    margin-bottom: 1.5rem;
`;
const OfferBoxPlaceholderInfo2Styles = (theme: Theme) => css`
    bottom: 1.5rem;
    height: 39px;
    background-color: ${theme.colors.gray[200]};
`;
const OfferBoxPlaceholderStyles = css`
    height: 0;
    overflow: hidden;
    padding-top: 125%;
    background: white;
    position: relative;
`;

const OfferBoxPlaceholderInnerStyles = css`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
